"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ShoppingTagFilled = function ShoppingTagFilled(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.854 7.86a.5.5 0 01-.708 0 3.637 3.637 0 01-.915-2.021 3.789 3.789 0 00-.97-2.105A2.392 2.392 0 0017.543 3a2.515 2.515 0 00-1.811.74 2.882 2.882 0 00-.2 3.723.5.5 0 11-.814.579 3.874 3.874 0 01.3-5.008A3.55 3.55 0 0117.52 2h.033a3.384 3.384 0 012.428 1.04 4.778 4.778 0 011.228 2.592 2.735 2.735 0 00.645 1.52.5.5 0 010 .708zm-4.94-2.633a.745.745 0 00-.531-.22h-.3a1.991 1.991 0 00.273 1.877 1.5 1.5 0 01-2.445 1.738 5.041 5.041 0 01-.9-3.615h-1.452a.746.746 0 00-.532.22l-8.806 8.8a.751.751 0 000 1.063l6.691 6.689a.754.754 0 001.062 0l8.8-8.8a.756.756 0 00.226-.533V7.623a.754.754 0 00-.221-.531z",
    fill: "currentColor"
  })));
};

var _default = ShoppingTagFilled;
exports["default"] = _default;